import ReorderButtonSFC from "./ReorderButton.vue";
export const ReorderButton = ReorderButtonSFC;
